import { absolutePath } from "./absolutePath";

export const mapboxV6 = {
  token: () => absolutePath("mapbox_v6/token"),
};
